import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ReservationForm } from "./ReservationForm";

interface ReservationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  preSelectedChateau?: string;
  initialDateDebut?: Date;
  initialDateFin?: Date;
  onSuccess?: () => void;
}

export const ReservationDialog = ({ open, onOpenChange, preSelectedChateau, initialDateDebut, initialDateFin, onSuccess }: ReservationDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto p-0">
        <DialogHeader className="p-6 pb-0">
          <DialogTitle className="text-2xl font-display">Demande de Réservation</DialogTitle>
        </DialogHeader>
        <div className="p-6 pt-0">
          <ReservationForm 
            preSelectedChateau={preSelectedChateau} 
            initialDateDebut={initialDateDebut}
            initialDateFin={initialDateFin}
            onSuccess={onSuccess}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};